import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = 'rm_pending_promo';

export const getPendingPromo = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};

export const clearPendingPromo = () => {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
};

/**
 * Mounted once at the top of App. Detects ?promo=CODE in any URL,
 * stores it for auto-apply at checkout, then cleans the URL.
 */
export const PromoCatcher = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const { token } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const promo = params.get('promo');
    if (!promo) return;
    const code = promo.trim().toUpperCase();
    if (code.length < 3 || code.length > 32) return;
    try { localStorage.setItem(KEY, code); } catch { /* ignore */ }
    axios.post(`${API}/vouchers/track-share-click`, { code }).catch(() => {});
    if (token) {
      axios.post(`${API}/vouchers/promo-intent`, { code }, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {});
    }
    toast.success(
      language === 'fr'
        ? `Code promo ${code} enregistré — il sera appliqué automatiquement à votre commande`
        : `Promo code ${code} saved — it will be applied automatically at checkout`,
      { duration: 6000 }
    );
    params.delete('promo');
    navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return null;
};
